export enum EAccountStatus {
  Unknown,
  Active,
  Cancelled,
  Prospect,
  ReviewingContract
}

export enum EPartnersStateType {
  SRS,
  ER,
  CarFaxAuth,
  CarFaxActivate,
  DealerOnly,
  JDPower,
  DeficiencyTracking,
  VRM,
  Reindeer,
}

export enum EConnectServiceState {
  Pending,
  Authorized,
  Removed,
}

export enum EAccountPage {
  Add          = 'add',
  Edit         = 'edit',
  Search       = 'search',
  Comments     = 'comments',
  Invoices     = 'invoices',
  Auctions     = 'auctions',
  Partners     = 'partners',
  Salespersons = 'salespersons',
  NadaAuctions = 'nada-auctions',
  Users        = 'users',
  Reports      = 'reports',
  Statistics   = 'services-statistics',
}

export enum EAccountSubpage {
  Details       = 'details',
  Photos        = 'photos',
  ReportDetails = 'report-details',
}
